module.exports = __webpack_public_path__ + "img/box9-03.22d127a2.png";